import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const GasStationPageContent = lazy(() => import("./GasStationsPageContent"));

function GasStationPageInternal() {
    return (
        <DefaultPage>
            <GasStationPageContent />
        </DefaultPage>
    );
}

export const GasStationsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    GasStationPageInternal
);
